<section class="container error-container">
	<div class="main">
		<h1>Oops! Page expired.</h1>
		<p>
		  This page has expired. Please log in again to continue accessing your account.
		</p>
		<p>Reference: {{ this.ref }}</p>
		<br />
	</div>
</section>
